/*@ngInject*/
const PolicyIssuanceActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadPolicyIssuanceActions = function (policyIssuanceId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.issuance.PolicyIssuance:' + policyIssuanceId + '&registrationIdentifier=/PolicyIssuance/' + policyIssuanceId,
            cacheKey = 'policyIssuanceActions:' + policyIssuanceId;

        if (currentSubmissionModel.hasActionsRegistration('/PolicyIssuance/' + policyIssuanceId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/PolicyIssuance/' + policyIssuanceId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('policyIssuanceActionsRepository', PolicyIssuanceActionsRepository);
